var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2104_900",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000145764970375413552160000008632945535419690397_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2104_900)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2104_900",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 26,
    height: 26
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000047019536052830994740000013529929270179697330_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.8861 -0.887695H-0.891602V24.89H24.8861V-0.887695Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2104_900)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -0.97168,
    y: -0.957031,
    width: 25.9411,
    height: 25.8558,
    fill: "#828282"
  }))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9981 5.80654C14.0156 5.80654 14.2544 5.81416 15.0512 5.85058C15.7879 5.88418 16.188 6.00729 16.4542 6.11063C16.8069 6.24757 17.0585 6.41134 17.323 6.6759C17.5873 6.94018 17.7511 7.19204 17.8883 7.5447C17.9917 7.81096 18.1148 8.21105 18.1484 8.94771C18.1848 9.74451 18.1924 9.98338 18.1924 12.0008C18.1924 14.0182 18.1848 14.2571 18.1484 15.0539C18.1148 15.7905 17.9917 16.1906 17.8883 16.4569C17.7514 16.8095 17.5876 17.0611 17.323 17.3257C17.0588 17.59 16.8069 17.7537 16.4542 17.891C16.188 17.9943 15.7879 18.1174 15.0512 18.151C14.2547 18.1874 14.0158 18.1951 11.9981 18.1951C9.98045 18.1951 9.74158 18.1874 8.94507 18.151C8.20841 18.1174 7.80831 17.9943 7.54205 17.891C7.18939 17.754 6.93782 17.5903 6.67325 17.3257C6.40897 17.0614 6.24521 16.8095 6.10798 16.4569C6.00464 16.1906 5.88154 15.7905 5.84794 15.0539C5.81151 14.2571 5.80389 14.0182 5.80389 12.0008C5.80389 9.98338 5.81151 9.74451 5.84794 8.94771C5.88154 8.21105 6.00464 7.81096 6.10798 7.5447C6.24492 7.19204 6.40869 6.94047 6.67325 6.6759C6.93754 6.41162 7.18939 6.24785 7.54205 6.11063C7.80831 6.00729 8.20841 5.88418 8.94507 5.85058C9.74187 5.81444 9.98074 5.80654 11.9981 5.80654ZM11.9981 4.44531C9.94629 4.44531 9.68878 4.45407 8.88295 4.49077C8.07881 4.52748 7.52963 4.6551 7.04878 4.84202C6.55184 5.03515 6.13057 5.2935 5.71043 5.71336C5.29029 6.1335 5.03194 6.55477 4.83909 7.05171C4.65245 7.53228 4.52455 8.08145 4.48784 8.88588C4.45114 9.69171 4.44238 9.94894 4.44238 12.0011C4.44238 14.0529 4.45114 14.3104 4.48784 15.1163C4.52455 15.9204 4.65217 16.4696 4.83909 16.9504C5.03222 17.4474 5.29057 17.8687 5.71043 18.2888C6.13057 18.7089 6.55184 18.9673 7.04878 19.1601C7.52935 19.3468 8.07852 19.4747 8.88295 19.5114C9.68878 19.5481 9.94601 19.5568 11.9981 19.5568C14.05 19.5568 14.3075 19.5481 15.1133 19.5114C15.9175 19.4747 16.4667 19.3471 16.9475 19.1601C17.4445 18.967 17.8657 18.7087 18.2859 18.2888C18.706 17.8687 18.9644 17.4474 19.1572 16.9504C19.3438 16.4699 19.4717 15.9207 19.5085 15.1163C19.5452 14.3104 19.5539 14.0532 19.5539 12.0011C19.5539 9.94894 19.5452 9.69171 19.5085 8.88588C19.4717 8.08174 19.3441 7.53256 19.1572 7.05171C18.9641 6.55477 18.7057 6.1335 18.2859 5.71336C17.8657 5.29322 17.4445 5.03487 16.9475 4.84202C16.4669 4.65538 15.9178 4.52748 15.1133 4.49077C14.3075 4.45407 14.0503 4.44531 11.9981 4.44531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.998 8.12109C9.8552 8.12109 8.11816 9.85813 8.11816 12.0009C8.11816 14.1437 9.8552 15.8807 11.998 15.8807C14.1408 15.8807 15.8778 14.1437 15.8778 12.0009C15.8778 9.85813 14.1408 8.12109 11.998 8.12109ZM11.998 14.5195C10.6071 14.5195 9.47939 13.3918 9.47939 12.0009C9.47939 10.61 10.6071 9.48232 11.998 9.48232C13.3888 9.48232 14.5166 10.61 14.5166 12.0009C14.5166 13.3918 13.3888 14.5195 11.998 14.5195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.6723 8.60885C17.0263 8.25479 17.0263 7.68075 16.6723 7.32669C16.3182 6.97263 15.7442 6.97263 15.3901 7.32669C15.036 7.68075 15.036 8.2548 15.3901 8.60886C15.7442 8.96292 16.3182 8.96291 16.6723 8.60885Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.4dd42cdb25f9c1115eaa172172a6d1fb.svg";
export { ForwardRef as ReactComponent };